'use client';

import React from 'react';
import Box from '@mui/material/Box';
import Menu from './Menu';
import { useBodyClassName, useHtmlClassName } from '@/utils/hooks';

const MENU_LIST = [
  { title: '个人隐私保护协议', id: 't0' },
  { title: '一、个人信息收集与使用', id: 't1' },
  { title: '二、我们如何使用cookie和其它同类技术', id: 't2' },
  { title: '三、个人信息共享', id: 't3' },
  { title: '四、未成年人的个人信息保护', id: 't4' },
  { title: '五、《个人隐私保护协议》变更', id: 't5' },
  { title: '六、联系我们', id: 't6' },
  { title: '七、适用法律', id: 't7' },
];

const PrivacyPage = () => {
  useBodyClassName('bg-white');
  useHtmlClassName('scroll-pt-20');

  return (
    <Box
      className="mx-auto flex justify-between relative"
      sx={{ width: '67.5rem', marginTop: '2.875rem' }}
    >
      <Menu menuData={MENU_LIST} />
      <Box
        className="text-black"
        sx={{
          width: '46.25rem',
          h1: {
            fontWeight: 600,
            marginTop: '2.5rem',
            marginBottom: '1.5rem',
            fontSize: '1.5rem',
            lineHeight: '2rem',
          },
          h2: {
            fontWeight: 600,
            marginTop: '1.5rem',
            marginBottom: '1.25rem',
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
          },
          h3: {
            fontWeight: 600,
            marginTop: '0.5rem',
            marginBottom: '1rem',
            fontSize: '1rem',
            lineHeight: '1.5rem',
          },
          ul: {
            margin: 0,
            li: {
              marginBottom: '.75rem',
              marginLeft: '1.3125rem',
            },
          },
          p: {
            fontSize: '.875rem',
            lineHeight: '1.625rem',
          },
        }}
      >
        <Box
          id={MENU_LIST[0].id}
          sx={{
            '& h1': {
              marginTop: 0,
              marginBottom: '2rem',
            },
          }}
        >
          <h1>{MENU_LIST[0].title}</h1>
          <p className="mb-3">【生效日期：2023年3月30日】</p>
          <p className="mb-3">
            尊敬的用户，欢迎您注册谈职账号并使用谈职专属服务。
          </p>
          <p className="mb-3">
            《谈职选才个人隐私保护协议》（以下简称“本协议”）是由您（用户）与公司（苏州谈职选才科技有限公司）就谈职招聘提供的平台所订立的隐私协议。本协议旨在提供您招聘信息和个人隐私信息的保护。本协议适用于我们收集的招聘信息，但
            <strong>
              不适用于通过我们的网站或服务而收集的其他信息及通过平台的产品及服务而对接的其他第三方产品或服务。
            </strong>
          </p>
          <p>
            在您使用谈职专属服务时，谈职选才可能会收集和使用您的相关信息。本协议解释了我们在提供服务的过程中如何收集、储存和使用这些相关信息，以及我们为您提供的控制和保护这些信息的方式。
            <strong>
              请您务必在点击同意本协议之前，审慎阅读、充分理解各条款内容，特别是涉及个人信息收集及处理相关条款、免除或者限制责任的条款、法律适用和争议解决条款。敏感个人信息、免除或者限制责任等重点条款将以粗体标识部分应重点阅读。
            </strong>
            如您对本协议内容有任何疑问，可通过本协议提供的联系方式联系我们。当您点击确认同意本协议并开始使用谈职专属服务，即表示您已充分阅读、理解且接受本协议的全部内容，且与谈职选才平台就相关内容达成一致，本协议对谈职及您均具有法律约束力。
          </p>
        </Box>
        <div id={MENU_LIST[1].id}>
          <h1>{MENU_LIST[1].title}</h1>
          <h2>（一）个人信息收集</h2>
          <p className="mb-3">
            根据《常见类型移动互联网应用程序必要个人信息范围规定》，谈职选才招聘平台对平台功能进行了基本业务功能及扩展功能两种功能。
            <strong>
              基本业务功能包括：职位发布、职位展示、投递简历等功能，收集使用的必要个人信息为：您的移动电话号码和您提供的简历（创建简历+导出简历）
            </strong>
            ，如您拒绝提供该类信息的，将无法使用谈职的基本业务功能。同时为更好地为您提供基本业务功能，平台还需要您提供其他一些非必要但有关联的个人信息，您可以选择拒绝填写。除基本业务功能之外，
            <strong>
              平台还会为您提供其他多样化的扩展业务功能，如职位搜索、职位数据及薪资分析、团队文化偏好测试、公司公开页浏览等功能。
            </strong>
            谈职为更全面保护用户知情同意权、实现最小必要原则要求，特推出游客模式。在此功能下，您可在不同意本政策、未登录的状态下使用谈职为您提供的相关扩展业务的功能。
          </p>
          <p className="mb-3">
            为保护申请人的个人隐私信息的安全，谈职将按照最严格的标准来处理和储存所有前述收集的信息的，也确保这些信息将只用作申请遴选及其他无特殊说明的用途。
          </p>
          <h3>（1）用户注册/登陆</h3>
          <p>
            您在使用谈职提供的专属服务时，首先需要注册成为谈职用户，此过程需要向谈职提供您本人的手机号码，谈职将通过发送短信验证码的方式来验证您的身份是否有效。
          </p>
          <h3>（2）简历创建</h3>
          <p className="mb-3">
            如您是求职者用户，当您使用求职功能以创建/编辑在线简历时，您需要完善如下信息：
          </p>
          <ul>
            <li>
              个人信息：姓名、出生年月、性别、现居城市、邮箱、电话、当前职位、求职状态、预计入职时间以及其他信息；
            </li>
            <li>
              求职偏好：期望职位、期望城市、期望薪资区间、求职类型及工作方式；
            </li>
            <li>
              教育经历：学校名称、学历、学历性质、专业、在校时间及校园经历；
            </li>
            <li>
              工作经历：公司名称、公司行业、在职时间、职位类型及工作经历；
            </li>
            <li>技能：您现在的期望职位或以往担任职位所掌握的专业技能；</li>
            <li>项目经历：您曾担任职位中所参与或主导的项目细节；</li>
          </ul>
          <p>
            除前述信息外，您还可以根据您的意愿，选择填写其他信息，包括头像（选择照片）、文化偏好测试等。双方均有选择意向时，招聘者能看到您的真实手机号码。
          </p>
          <h3>（3）认证招聘者身份</h3>
          <p className="mb-3">
            根据《人力资源市场暂行条例》及《网络招聘服务管理规定》，网络招聘服务平台需对用人单位及其经办人员身份进行审查。
            <strong>
              若您作为公司招聘者，则需要提供您的个人姓名、职务、邮箱及所加入公司全称；若您所加入的公司尚未进行公司注册，您则需要提供身份信息（真实姓名及身份证号）以进行支付宝人脸识别认证（具体要求以注册页面的指示为准）；另外，还需提供您所属的公司信息及相应资质。此类信息属于认证招聘者身份功能的必要信息，如您不能或拒绝提供上述信息，将无法完成招聘者身份认证（您将继续以求职者身份使用服务及相关功能）。身份信息和实名认证信息（涉及生物识别）属于个人敏感信息，我们会在您触发相关功能时另行单独取得您的授权同意，且仅接受校验结果，不存储生物识别信息。
            </strong>
          </p>
          <p className="mb-3">
            在您提交公司相应资质文件时，需要调用您设备的存储权限以便您上传设备中的文件及照片或相册权限以上传照片，如果您拒绝相关浏览器系统权限将影响您提交资质并最终影响您使用认证企业招聘身份功能。
          </p>
          <p>
            注：您代表用人单位认证招聘人员账号所提交的用人单位资质材料（包括但不限于用人单位的执照、用人单位出具的经办人员身份证明/委托证明等），并不属于您的个人信息，而是用于证明用人单位的资质及真实招聘需求。您作为用人单位招聘人员代表企业在平台上提供的信息及使用平台所产生的信息，用人者均有权向平台申请获取或查看上述信息。
          </p>
          <h3>（4）职位发布功能（招聘者用户）</h3>
          <p>
            当您作为招聘者使用职位功能编辑公司信息时，您需要提供位置信息（如所在城市、地区）以便明确公司所在地址及职位要求的工作地址。此类信息为招聘者用户创建公司功能必要信息，由您手动输入填写。
          </p>
          <h2>（二）如何使用已收集的个人信息</h2>
          <h3>（1）算法匹配</h3>
          <p>
            <strong>
              为了使您能够更为精准的得到心仪的公司以及人才信息，谈职特推出了专属的匹配机制。网站需收集求职用户的简历信息及文化偏好测试结果、公司的相关主页信息及发布的职位信息，以供向您提供客观、准确的匹配结果。
            </strong>
            为了提高求职或招聘效率及成功率，经您同意后，谈职网站会对收集的招聘信息和求职
            信息进行匹配，向您进行职位及人才推送。
          </p>
          <h3>（2）敏感信息调用</h3>
          <p className="mb-3">
            若您为求职用户，在您选择照片、图像上传为个人头像时，需要调用您设备的存储权限/相册权限。若您拒绝相关系统权限，您可能无法选择或使用心仪的头像，但不影响您使用完善在线简历功能。
          </p>
          <p>
            若您为企业端用户，在您选择人脸识别以进行实名认证时，需要调用您设备的相机权限以获取您的面部生物信息，此为人脸识别所必须的系统权限，若您拒绝调用将无法使用人脸识别功能，从而导致无法创建或加入公司。您在发布职位信息或完善公司信息时还可以在其中添加公司介绍视频及图片，该视频及图片从您的本地设备（PC）上传至相关页面，需要调用您设备的存储权限（Android系统）/相机权限（IOS系统）。若您拒绝本网站调用相关系统权限，将无法上传相关视频及图片，但不影响您编辑其他职位信息。
          </p>
          <h3>（3）网站安全</h3>
          <p>
            为了保障您使用谈职服务的人身、财产安全，更好地预防求职诈骗财产风险、人身安全风险，以及更准确地识别违反法律法规及谈职相关协议、规则的行为，本网站会记录、整合、使用您的设备属性及状态信息（包括设备标识符（IMEI/MEID/ESN、androidID、OAID、IDFA、GUID、IMSI、ICCID、硬件序列号、设备电量、待机时长）、应用信息（本应用崩溃情况、性能数据、应用来源）、IP
            地址、MAC 地址、及设备型号、操作系统版本、运营商信息）和WiFi
            信息（SSID、BSSID
            及网络质量和状态数据）、网站内沟通记录，用于判断您的账号风险、进行身份验证、检测本网站认为存在风险的行为以及防范平台安全事件，并采取必要的记录、审计、分析、处置措施。
          </p>
          <h3>（4）第三方SDK</h3>
          <p>
            我们需要使用支付宝人脸识别以便确认公司真实资质，您可以通过拒绝系统权限来阻止其获得您的人脸信息。
          </p>
        </div>
        <div id={MENU_LIST[2].id}>
          <h1>{MENU_LIST[2].title}</h1>
          <ul>
            <li>
              <p>
                Cookie是您登录网站或浏览网络内容时，网站服务器存放在您的电脑、移动电话或其他智能终端设备内的小型文件，通常包含标识符、站点名称以及一些号码和字符。当您再次访问相应网站时，网站就可通过
                Cookie 识别您的浏览器。Cookie可能会存储用户偏好及其他信息。
              </p>
            </li>
            <li>
              <p>
                我们可能通过Cookies或同类技术收集您的登录IP地址信息、用户登陆状态以及缓存您的浏览信息、点击信息，以查看您的网络环境。通过Cookies，我们可以在您访问网站时识别您的身份，并不断优化网站的用户友好程度，并根据您的需要对网站做出调整。您也可以更改浏览器的设置，使浏览器不接受我们网站的Cookies，但这样可能会影响您对网站的部分功能的使用。在谈职网站，借助于Cookie和其他类似技术，我们可以在您每次使用产品与/或服务时识别您是否属于我们的用户，而不必在每个页面上重新登录和验证。
              </p>
            </li>
          </ul>
        </div>
        <div id={MENU_LIST[3].id}>
          <h1>{MENU_LIST[3].title}</h1>
          <p>
            本网站绝不会出售或出租任何申请人的个人资料。除了本政策中明确允许的情况外，我们将不向任何第三方的分享申请人提供的所有信息。除了本政策中明确允许的情况外，申请人的信息可能会被转让到与我们有关系的下辖公司和团体，以帮助我们在招聘过程中进行跟踪。
          </p>
        </div>
        <div id={MENU_LIST[4].id}>
          <h1>{MENU_LIST[4].title}</h1>
          <p className="mb-3">
            基于谈职选才的内容及服务性质，本网站不收集未成年人的个人隐私信息且不向十六周岁以下的未成年人提供服务，一旦发现未成年人的个人隐私信息，本网站将尽快删除，且不使用。
          </p>
          <p>
            如您为未满十六周岁的未成年人，请您立即告知您的监护人或法定代理人，并由监护人或法定代理人陪同立即终止使用本网站，并勿向网站提供任何个人信息。
          </p>
        </div>
        <div id={MENU_LIST[5].id}>
          <h1>{MENU_LIST[5].title}</h1>
          <p>
            谈职会根据业务发展情况，不断调整本隐私保护协议，以确保招聘者个人信息的安全有效地使用。相关变更我们将在网站上发布，敬请留意。
          </p>
        </div>
        <div id={MENU_LIST[6].id}>
          <h1>{MENU_LIST[6].title}</h1>
          <p>如果您对谈职的《个人隐私保护协议》有任何疑问，请联系我们：</p>
          <p>邮箱：contact@tanzhi.cn</p>
        </div>
        <Box id={MENU_LIST[7].id} sx={{ ul: { li: { marginLeft: 0 } } }}>
          <h1>{MENU_LIST[7].title}</h1>
          <ul className="list-none">
            <li>
              <p>
                1、本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，请参照商业惯例及/或行业惯例。
              </p>
            </li>
            <li>
              <p>
                2、用户因使用谈职选才平台服务所产生的与谈职平台有关的纠纷，谈职将与用户协商解决。协商未果时，任何一方均有权向当地管辖人民法院提起诉讼。
              </p>
            </li>
          </ul>
        </Box>
      </Box>
    </Box>
  );
};

export default PrivacyPage;
